/**
 * Canonical site URL for SEO, Open Graph, JSON-LD, and hreflang.
 * Override in build with VITE_PUBLIC_SITE_URL (no trailing slash).
 */
export function getSiteUrl () {
  const env =
    (typeof import.meta !== 'undefined' && import.meta.env && import.meta.env.VITE_PUBLIC_SITE_URL) ||
    (typeof process !== 'undefined' && process.env && process.env.VITE_PUBLIC_SITE_URL)
  if (env && typeof env === 'string') {
    return env.replace(/\/$/, '')
  }
  return 'https://vivapsychotherapy.com'
}

/** Stable @id for Organization / MedicalBusiness in JSON-LD across pages */
export function getOrganizationSchemaId () {
  return `${getSiteUrl()}/#organization`
}

export function getWebsiteSchemaId () {
  return `${getSiteUrl()}/#website`
}

/**
 * Absolute URL for the social preview image (2400×1260 PNG, 1.91:1).
 * Dedicated filename so WhatsApp / Facebook do not keep a cached portrait.
 */
export function getOgImageUrl () {
  return `${getSiteUrl()}/og-share.png`
}

/**
 * Join site origin with a path (path must start with /).
 */
export function absoluteUrl (path) {
  const base = getSiteUrl()
  if (!path || path === '/') return `${base}/`
  const p = path.startsWith('/') ? path : `/${path}`
  return `${base}${p}`
}

/**
 * Strip /en or /pt prefix for hreflang alternates.
 * @returns {{ lang: 'en'|'pt'|'default', suffix: string }} suffix is '/' or '/about', etc.
 */
export function parseLocalizedPathname (pathname) {
  if (!pathname || pathname === '/') {
    return { lang: 'default', suffix: '/' }
  }
  if (pathname === '/pt' || pathname.startsWith('/pt/')) {
    let rest = pathname.slice(3)
    if (!rest) rest = '/'
    return { lang: 'pt', suffix: rest.startsWith('/') ? rest : `/${rest}` }
  }
  if (pathname === '/en' || pathname.startsWith('/en/')) {
    let rest = pathname.slice(3)
    if (!rest) rest = '/'
    return { lang: 'en', suffix: rest.startsWith('/') ? rest : `/${rest}` }
  }
  return { lang: 'default', suffix: pathname.startsWith('/') ? pathname : `/${pathname}` }
}

/**
 * en, pt, and x-default absolute URLs for a logical route (suffix without locale prefix).
 */
export function getHreflangTriple (suffix) {
  const site = getSiteUrl()
  const s = suffix === '' ? '/' : (suffix.startsWith('/') ? suffix : `/${suffix}`)
  const enPath = s === '/' ? '/en' : `/en${s}`
  const ptPath = s === '/' ? '/pt' : `/pt${s}`
  const xPath = s === '/' ? '/' : s
  return {
    en: absoluteUrl(enPath),
    pt: absoluteUrl(ptPath),
    xDefault: absoluteUrl(xPath)
  }
}
